import React, { Component } from 'react';

class Footer extends Component {
    render() {
        return (
            <footer className="sticky-footer bg-white mt-5">
                <div className="container my-auto">
                    <div className="copyright text-center my-auto">
                        <span>Copyright © hoanghai.reg@gmail.com 2020</span>
                    </div>
                </div>
            </footer>

        );
    }
}

export default Footer;